export class BloqueioDesbloqueioAgendaPrestadorDTO {
  constructor(
    private data: string,
    private hora: string,
    private idEspecialidade: number,
    private idPrestador: number
  ) { }
}